'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/8/8.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ExperienceShopInfo, _Component);

  function ExperienceShopInfo() {
    (0, _classCallCheck3.default)(this, ExperienceShopInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopInfo).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopInfo, [{
    key: 'render',
    value: function render() {
      var styles = require('./ExperienceShopInfo.scss');
      var _props = this.props;
      var index = _props.index;
      var shop = _props.shop;
      var pathName = _props.pathName;

      var rightClassName = '';
      if ((index + 1) % 3 === 0) {
        rightClassName = styles.mr0 + ' ' + styles.w420;
      }
      return _react2.default.createElement(
        'li',
        { className: styles.component + ' ' + rightClassName },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: (pathName || '/experienceshopdetail/') + shop.id, className: styles.link, target: '_blank' },
          _react2.default.createElement('img', { className: styles.img,
            src: shop.img || 'http://tupian.goeasy.cn:9999/yipinwang/experienceshopdefault.jpg', alt: '' }),
          _react2.default.createElement(
            'p',
            { className: styles.text, style: { height: '80px', paddingTop: '20px' } },
            _react2.default.createElement(
              'span',
              { className: styles.shopName, style: { fontWeight: '500', fontSize: '22px' } },
              shop.name
            ),
            _react2.default.createElement('br', null),
            shop.province ? _react2.default.createElement(
              'span',
              { className: styles.shopAddress },
              shop.province
            ) : '',
            shop.province && shop.city ? _react2.default.createElement(
              'span',
              { className: styles.shopAddress },
              ' • '
            ) : '',
            shop.city ? _react2.default.createElement(
              'span',
              { className: styles.shopAddress },
              shop.city
            ) : '',
            _react2.default.createElement('img', { className: styles.logo, src: shop.logo, alt: '' })
          )
        )
      );
    }
  }]);
  return ExperienceShopInfo;
}(_react.Component), _class.propTypes = {
  index: _react.PropTypes.number.isRequired,
  shop: _react.PropTypes.object.isRequired,
  pathName: _react.PropTypes.string.isRequired
}, _temp);
exports.default = ExperienceShopInfo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ExperienceShopInfo/ExperienceShopInfo.js
 ** module id = 1330
 ** module chunks = 0
 **/